import React, { useCallback } from 'react';

function Ending({ root, dir, level, number, onClick }) {
  const onClose = useCallback(() => {
    root.dispatchEvent(
      new CustomEvent('ended', {
        detail: {
          level: level + 1,
          number: number + 1,
        },
      })
    );
    onClick();
  }, []);
  return (
    <div className="questionContent questionEnding questionEnding01">
      <div className="questionTxt">
        <div className="questionTxtInner">
          <p>
            キミのおかげで未来のみどりが守られたぞ
            <br />
            ありがとう!
          </p>
          <p>
            <img src={dir + 'assets/img/img-last.png'} alt="" className="imgLast" />
          </p>
        </div>
        <button onTouchStart={() => {}} className={'questionBtn questionNextBtn2 btn-' + Number(number + 1)} onClick={onClose}>
          <img src={dir + 'assets/img/btn-next2.png'} alt="次へ" />
        </button>
      </div>
    </div>
  );
}

export default Ending;
